import * as z from "zod";
import { defineStreamChannelSchema } from "./definitions";

export const exampleStreamInitialSchema = z.object({
  _tag: z.literal("exampleInitial"),
  items: z.array(z.string()),
  scope: z.string(),
});
export type ExampleStreamInitial = z.infer<typeof exampleStreamInitialSchema>;

export const exampleStreamEventSchema = z.object({
  _tag: z.literal("exampleUpdated"),
  item: z.string(),
  scope: z.string(),
});
export type ExampleStreamEvent = z.infer<typeof exampleStreamEventSchema>;

export const exampleStreamInputSchema = z.object({
  scope: z.string().default("default"),
});
export type ExampleStreamInput = z.infer<typeof exampleStreamInputSchema>;

export const exampleStreamChannelSchema = defineStreamChannelSchema({
  eventSchema: exampleStreamEventSchema,
  initialSchema: exampleStreamInitialSchema,
  inputSchema: exampleStreamInputSchema,
});
